export enum AddTargetValuesTabs {
    Paste = 0,
    Upload = 1,
}

export enum ManageTargetModalScreen {
    Create = 0,
    Paste = 1,
    Manage = 2,
}
